/* eslint-disable no-shadow */
export enum ApiKeyStatus {
	ACTIVE = 'active',
	REVOKED = 'revoked',
}

export interface ApiKey {
	_id: string;
	label: string;
	keyPrefix: string;
	status: ApiKeyStatus;
	lastUsedAt?: Date;
	createdAt: Date;
}

export interface CreateApiKeyDto {
	label: string;
}

export interface ApiKeyCreatedResponse {
	_id: string;
	label: string;
	apiKey: string;
}
